<template>
  <div
    :style="{
      'width': width,
      'height': height,
      'background': backgroundColor
    }">
    <div 
      :id="elementId" 
      style="width: 100%; height: 100%">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'd3chart',
    props: {
      elementId: {
        type: String,
        default: 'hello'
      },
      // 初始化展示tooltip
      firstTooltip: {
        type: Boolean,
        default: false
      },
      enableResize: {
        type: Boolean,
        default: false
      },
      configsType:{
        type: String,
        default: 'doubleBar', 
      },
      width:{
        type: String,
        default: '286px', 
      },
      height:{
        type: String,
        default: '158px', 
      },
      backgroundColor:{
        type: String,
        default: 'none', 
      },
      originData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      option: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data(){
      return {
        chart: {}
      }
    },
    watch: {
      originData: {
        handler(newvalue, oldvalue){
          if (!newvalue.length) { return }
          let configs = this.$chartConfigs[this.configsType];
          if (typeof configs === 'function') {
            configs = configs()
          }
          let option = Object.assign({}, this.option.series ? this.option : configs, {
              data: newvalue
          });
          let {blue} = this.$chartConfigs.projectColors;
          if (option.series[0].type === 'arc') {
            for (let i = 0; i < option.series.length; i++) {
              let value = option.data[0].originData[i].values[0].value
              option.series[i].itemStyle.normal = {
                fill: blue,
                stroke: blue,
                opacity: 0.5,
                cornerRadius: 0
              }
              option.series[i].startArc.normal = {
                fill: blue,
                stroke: blue,
                cornerRadius: 0
              }
              option.series[i].endArc.normal = {
                fill: blue,
                stroke: blue,
                cornerRadius: 0
              }

              // option.series[i].itemStyle.normal = {
              //   fill: this.judgeArcColor(value),
              //   stroke: this.judgeArcColor(value),
              //   cornerRadius: 0
              // }
              // option.series[i].startArc.normal = {
              //   fill: this.judgeSideColor(value),
              //   stroke: this.judgeSideColor(value),
              //   cornerRadius: 0
              // }
              // option.series[i].endArc.normal = {
              //   fill: this.judgeSideColor(value),
              //   stroke: this.judgeSideColor(value),
              //   cornerRadius: 0
              // }
            }
          }
          // if (option.series[0].type === 'gauge') {
          //   let value = option.data[0].originData.value
          //   option.series[0].color = this.judgeGaugeColor(value)
          //   option.series[0].endArc.style = {
          //     fill: this.judgeGaugeEndColor(value),
          //     stroke: this.judgeGaugeEndColor(value)
          //   }
          // }
          this.chart.setOption(option);

          if(this.firstTooltip){
            this.chart.on('VIEW_DID_RENDER_AFTER_SET_OPTION', ()=> {

              var tooltipModel = this.chart.getModel('tooltip', 0);
              var tooltipView = this.chart.getViewOfComponentModel(tooltipModel);
              var axisModel = this.chart.getModel('axis', 0);

              tooltipView.showTooltip(tooltipModel, axisModel.getLastData());
            });
          }

        }
      }
    },
    mounted(){
      this.chart = D3Charts.init(this.elementId);
      
      if(this.enableResize){
        window.addEventListener("resize", ()=> {
          this.chart.resize();
        });
      }
    },
    methods: {
      resize(){
        this.chart.resize();
      },
      judgeArcColor (val) {
        let color = ''
        if (val >= 0 && val < 0.3) {
          color = 'rgba(0, 150, 255, 0.5)'
        } else if (val >= 0.3 && val <= 0.7) {
          color = '#6F7018'
        } else {
          color = '#95352E'
        }
        return color
      },
      judgeSideColor (val) {
        let color = ''
        if (val >= 0 && val < 0.3) {
          color = this.$chartConfigs.projectColors.blue
        } else if (val >= 0.3 && val <= 0.7) {
          color = this.$chartConfigs.projectColors.yellow
        } else {
          color = this.$chartConfigs.projectColors.red
        }
        return color
      },
      judgeGaugeColor (val) {
        let color = []
        if (val >= 0 && val < 30) {
          color = [[0, '#1E2833'], [1, '#154264']]
        } else if (val >= 30 && val <= 70) {
          color = [[0, '#282824'], [1, '#887918']]
        } else {
          color = [[0, '#2D2326'], [1, '#E33F30']]
        }
        return color
      },
      judgeGaugeEndColor (val) {
        let color = ''
        if (val >= 0 && val < 30) {
          color = this.$chartConfigs.projectColors.blue
        } else if (val >= 30 && val <= 70) {
          color = this.$chartConfigs.projectColors.yellow
        } else {
          color = this.$chartConfigs.projectColors.red
        }
        return color
      }
    }
  };
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>


</style>
